import { createRouter, createWebHistory } from 'vue-router';
import { getAuth, onAuthStateChanged } from 'firebase/auth';

import LandingView from '../views/LandingView.vue';

const routes = [
  {
    path: '/',
    name: 'Landing',
    component: LandingView,
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "home" */ '../views/HomeView.vue'),
    meta: { requiresAuth: true }, 
  },
  {
    path: '/search',
    name: 'search',
    component: () => import(/* webpackChunkName: "search" */ '../views/SearchView.vue'),
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginView.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import(/* webpackChunkName: "register" */ '../views/RegisterView.vue'),
  },
  {
    path: '/account',
    name: 'account',
    component: () => import(/* webpackChunkName: "account" */ '../views/AccountView.vue'),
    meta: { requiresAuth: true }, 
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "privacy" */ '../views/PrivacyPolicyView.vue'),
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/ContactView.vue'),
  },
  {
    path: '/novel/:ncode',
    name: 'novel-detail',
    component: () => import(/* webpackChunkName: "novel-detail" */ '../views/NovelDetailView.vue'),
    props: true,
  },
  {
    path: '/evaluated-list',
    name: 'EvaluatedList',
    component: () => import('../views/EvaluatedListView.vue'),
    meta: { requiresAuth: true }
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const removeListener = onAuthStateChanged(
      getAuth(),
      (user) => {
        removeListener();
        resolve(user);
      },
      reject
    );
  });
};

// ★★★ ここからナビゲーションガードを修正 ★★★
router.beforeEach(async (to, from, next) => {
  const currentUser = await getCurrentUser();
  const isLoggedIn = !!currentUser;

  // ログイン済みのユーザーがログインページや登録ページにアクセスした場合、ホームへリダイレクト
  if (isLoggedIn && (to.name === 'login' || to.name === 'register')) {
    return next({ name: 'Home' });
  }

  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  
  // ログインが必要なページに未ログインでアクセスした場合、Landingページへリダイレクト
  if (requiresAuth && !isLoggedIn) {
    return next({ name: 'Landing' });
  }
  
  // 上記以外の場合は、そのまま遷移を許可
  next();
});
// ★★★ ここまでナビゲーションガードを修正 ★★★

export default router;